

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/autoplay";
import "swiper/css/navigation";

function MainSlider() {
  const slides = ["hero_bg_3.jpg", "hero_bg_2.jpg", "hero_bg_1.jpg"];

  return (
    <div id="mainSlider">
      <div className="hero relative">
      {/* Swiper Slider */}
      <Swiper
        modules={[Autoplay, EffectFade]}
        effect="fade"
        loop
        autoplay={{
          delay: 6000,
          disableOnInteraction: false,
        }}
        className="hero-swiper"
      >
        {slides.map((img, i) => (
          <SwiperSlide key={i}>
            <div
              className="hero-slide-img"
              style={{
                backgroundImage: `url('assets/images/${img}')`,
              }}
            ></div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Black overlay gradient */}
      <div className="hero-gradient-overlay"></div>

      {/* Text content on top */}
      <div className="hero-overlay-content">
        <div className="text-center">
          <span
            className="flaticon-house-2 mb-4 d-block"
            style={{ fontSize: "130px", color: "#fff" }}
          ></span>
          <h2
            className="heading"
            data-aos="fade-up"
            style={{
              color: "#fff",
              fontWeight: "600",
              fontFamily:'icomoon'
            }}
          >
            Turning Your Dream Home Into Reality
          </h2>
        </div>
      </div>
    </div>
    </div>
  );
}

export default MainSlider;
